import { GraphEdge } from '../GraphEdge'

export function generateLinkEdges(templateField) {
  if (templateField.autofill) {
    return generateLinkAutofillEdges(templateField)
  }

  return []
}

function generateLinkAutofillEdges(templateField) {
  const { autofill } = templateField
  const fieldId = templateField.field_id
  const results = []

  if (autofill && autofill.field_id) {
    results.push(new GraphEdge(autofill.field_id, fieldId))
  }

  return results
}
